import { Table } from '@tanstack/react-table';

import { decimalToDuration } from '../../../../utils/dateUtil';

enum DurationFormat {
  HOURS_AND_MINUTES = 'hh:mm',
}

type Props = {
  column: {
    columnDef: {
      cellParams: {
        format?: DurationFormat;
      };
      accessor: string;
    };
  };
  table: Table<{ [key: string]: number }>;
};

export const DurationFooterCell = (props: Props) => {
  const { column } = props;
  const durationFormat =
    DurationFormat[column?.columnDef?.cellParams?.format] ??
    DurationFormat.HOURS_AND_MINUTES;

  const value = props.table
    ?.getRowModel()
    .rows.reduce(
      (sum, cur) => sum + cur.original[column?.columnDef?.accessor] || 0,
      0
    );
  return (
    <div style={{ textAlign: 'right' }}>
      {decimalToDuration(value).toFormat(durationFormat)}
    </div>
  );
};
